(() => {
  'use strict';
  if (window.simcaddyScreenPromoLoaded) return;
  window.simcaddyScreenPromoLoaded = true;
  const restoreDestinations = (root = document) => {
    root.querySelectorAll('[data-sc-promo-destination]').forEach(link => {
      // Keep this optional section's merchant-selected URL after V43's shared routing runs.
      const destination = new URL(link.dataset.scPromoDestination, window.location.origin);
      const preview = new URLSearchParams(window.location.search).get('preview_theme_id');
      if (destination.origin === window.location.origin && preview && /^\d+$/.test(preview)) {
        destination.searchParams.set('preview_theme_id', preview);
      }
      link.href = destination.href;
    });
  };
  const schedule = (root = document) => queueMicrotask(() => restoreDestinations(root));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => schedule());
  else schedule();
  document.addEventListener('shopify:section:load', event => schedule(event.target));
})();
